'use client';

import { useEffect, useState } from 'react';

import { signOut, useSession } from '../../lib/better-auth/client';
import { isAdmin } from '../../lib/rbac';

export function useAuth() {
  const { data: session, isPending } = useSession();
  const [redirectToHome, setRedirectToHome] = useState(false);

  const user = session?.user ?? null;
  const loading = isPending;
  const userRole = typeof (user as { role?: string })?.role === 'string' ? (user as { role?: string }).role : null;
  const isAdminUser = Boolean(userRole && isAdmin({ role: userRole }));

  const handleSignOut = async () => {
    await signOut();
    setRedirectToHome(true);
  };

  useEffect(() => {
    if (redirectToHome && typeof window !== 'undefined') {
      window.location.href = '/';
    }
  }, [redirectToHome]);

  return {
    user,
    loading,
    isAdmin: isAdminUser,
    signOut: handleSignOut,
  };
}
